import { List, Record } from 'immutable';
export const SUCCESS_APPEARANCE = 'success';
export const ERROR_APPEARANCE = 'error';
export const INFO_APPEARANCE = 'info';
export const WARNING_APPEARANCE = 'warning';
export function foldAppearance(appearance, success, error, info, warning) {
  switch (appearance) {
    case SUCCESS_APPEARANCE:
      return success();
    case ERROR_APPEARANCE:
      return error();
    case INFO_APPEARANCE:
      return info();
    case WARNING_APPEARANCE:
      return warning();
    default:
      throw new Error("foldAppearance is not comprehensive in Appearance: ".concat(appearance));
  }
}
export const makeFlagAction = Record({
  callback: () => {
    /* do nothing by default */
  },
  displayText: '',
  id: '',
  key: '',
  href: '',
  target: ''
});
const makeFlagActions = flag => {
  if (!flag.actions) {
    return List([]);
  }
  return List(flag.actions.map(action => {
    const flagAction = {
      displayText: action.content
    };
    if (action.href) flagAction.href = action.href;
    if (action.onClick) flagAction.callback = action.onClick;
    if (action.target) flagAction.target = action.target;
    return makeFlagAction(flagAction);
  }));
};
export const makeEmceeFlag = flag => {
  return makeFlag({
    key: flag.id,
    appearance: flag.type,
    title: flag.title,
    description: {
      primary: flag.description
    },
    autoDismiss: flag.isAutoDismiss,
    actions: makeFlagActions(flag)
  });
};
export const makeFlagDescription = Record({
  primary: '',
  secondary: undefined
});
export const makeFlag = Record({
  autoDismiss: true,
  actions: List(),
  appearance: SUCCESS_APPEARANCE,
  description: undefined,
  key: '',
  title: ''
});